// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Planoscontas_CreateTemplateInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /planoscontas/template
 *
 * Creates a new budget plan template for a franchise.
 *
 * Required:
 *   - franquia_id (int)
 *   - itens       (Planoscontas_CreateTemplateItemInputRow[]) — non-empty
 *
 * Optional:
 *   - nome (string|null)
 */
import type { Planoscontas_CreateTemplateItemInputRow } from './Planoscontas_CreateTemplateItemInputRow'
import { registerContract } from './validate'

export interface Planoscontas_CreateTemplateInput {
franquia_id: number
itens: Planoscontas_CreateTemplateItemInputRow[]
nome?: string
}

registerContract('Planoscontas_CreateTemplateInput', {
  franquia_id: { type: 'number',  required: true },
  itens: {
    type: 'array',
    required: true,
    items: {
      categoria_id:      { type: 'number',  required: true },
      tipo:              { type: 'string',  required: true },
      percentual_custom: { type: 'number',  required: false },
      valor_previsto:    { type: 'number',  required: false },
    },
  },
  nome:        { type: 'string',  required: false },
})
